// extracted by mini-css-extract-plugin
export default {"App":"App_App__hefVN","switch-wrapper":"App_switch-wrapper__zfNyO"};